// extracted by mini-css-extract-plugin
export default {"content":"style_content__amlEH","textarea":"style_textarea__RbItq","errorMsg":"style_errorMsg__Mvfb3","resetBtn":"style_resetBtn__Q+vBt"};